const getGTMPageLabel = (isDetailsPage: boolean): string =>
  isDetailsPage ? "Page: Project Details" : "Page: Project Dashboard";

const getNoResultsHeader = (isSearch: boolean): string =>
  isSearch
    ? "No Results"
    : "No Active New or Modification Electric/Gas Projects";

const getNoResultsMessage = (isSearch: boolean): string =>
  isSearch
    ? "Please modify your search and try again."
    : "New requests can take several business days to appear.";

export default { getGTMPageLabel, getNoResultsHeader, getNoResultsMessage };
